import { render, staticRenderFns } from "./avatar-darkmode.vue?vue&type=template&id=ec774be8&scoped=true&"
import script from "./avatar-darkmode.vue?vue&type=script&lang=js&"
export * from "./avatar-darkmode.vue?vue&type=script&lang=js&"
import style0 from "./avatar-darkmode.vue?vue&type=style&index=0&id=ec774be8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec774be8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
installComponents(component, {VAvatar})
